/* eslint-disable */
export default {
  hide: 'Ocultar',
  end: 'Terminar',
  keypad: 'Teclado',
} as const;

// @key: @#@"hide"@#@ @source: @#@"Hide"@#@
// @key: @#@"end"@#@ @source: @#@"End"@#@
// @key: @#@"keypad"@#@ @source: @#@"Keypad"@#@
